/* eslint-disable global-require */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom';

import './index.less';
import { applyMiddleware, createStore } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { ThemeProvider } from 'styled-components';
import { ConnectedRouter } from 'connected-react-router';
import history from './history';
import theme from './theme';
import * as serviceWorker from './serviceWorker';

import reducers from './state/reducers';
import sagas from './state/sagas';

import App from './App';

const middlewares = [];

if (process.env.NODE_ENV === 'development') {
  const { logger } = require('redux-logger');
  middlewares.push(logger);
}
const sagaMiddleware = createSagaMiddleware();
middlewares.push(sagaMiddleware);

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'navigation'],
};
const persistedReducer = persistReducer(persistConfig, reducers(history));

const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middlewares)));
sagaMiddleware.run(sagas);
const persistor = persistStore(store);

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <PersistGate loading={null} persistor={persistor}>
          <App history={history} />
        </PersistGate>
      </ConnectedRouter>
    </Provider>
  </ThemeProvider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
